import React from "react";

const AppML_Reference = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Reference</h1>
      <p>This is the AppML Reference page content.</p>
    </div>
  );
};

export default AppML_Reference;
